// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".organisation .organisation-details[data-v-d064cfda],.organisation .organisation-details h1[data-v-d064cfda]{display:none}", ""]);
// Exports
module.exports = exports;
